import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IHeaderState } from '@store';

export const selectHeaderState = createFeatureSelector<IHeaderState>('header');
export const selectHeaderLogged = createSelector(selectHeaderState, (state: IHeaderState) => state.loggedUser);
export const selectHeaderLang = createSelector(selectHeaderState, (state: IHeaderState) => state.lang);
